import { useEffect } from "react";

const BASE = "PostMint";

export default function Seo({ title, description, path = "/" }) {
  useEffect(() => {
    const full = title ? `${title} | ${BASE}` : `${BASE} — Your content. Done.`;
    document.title = full;

    const set = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [key, val] = selector.replace(/meta\[|\]/g, "").split("=");
        el.setAttribute(key, val.replace(/"/g, ""));
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) {
      set('meta[name="description"]', "content", description);
      set('meta[property="og:description"]', "content", description);
    }
    set('meta[property="og:title"]', "content", full);
    set('meta[property="og:type"]', "content", "website");
    set('meta[property="og:site_name"]', "content", BASE);
    set('meta[name="twitter:card"]', "content", "summary_large_image");

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${window.location.origin}${path}`);
  }, [title, description, path]);

  return null;
}
